import React, {Component} from 'react';
import {Form, FormGroup, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import {showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import Select from "../../local_node_modules/react-select";
import Alert from "react-s-alert";


class HakedisStateModal extends Component {

	constructor(props) {
		super(props);
		this.notify = React.createRef();
		this.state = {
				show: false,
				row:this.props.row,
				hakedisStates:[],
				hakedisState:null,
		};

		this.query = this.query.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
		this.onChangeState = this.onChangeState.bind(this);
		this.getOptions = this.getOptions.bind(this);
		this.onChange = this.onChange.bind(this);

	}

	componentDidMount() {
		this.setState({show: this.props.show});
		this.getOptions();
		console.log(this.state.row);
	}

	getOptions(){
		let self=this;
		let params = {
			url: "/progresspayment/getHakedisStates",
			method: 'get',
		};

		this.setState({processing: true});
		request(params).then(function (response) {
			let hakedisStates=response.data;
			console.log("response.data",response.data);
			self.setState({processing: false,hakedisStates});
		}).catch(function (error) {
			self.setState({processing: false});
			showAxiosError(error);
		});

	}


	toggleModal() {
		this.props.toggle(true);
	}

	query() {
		let self = this;
		if(!this.state.row){
			return;
		}

		if (!this.state.row.state.recordId) {
			Alert.error("Hakediş Durumu Seçmelisiniz!", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 3000
			});
			return;
		}
		if (this.state.row.state.recordId && this.state.row.state.recordId > 1 &&  (!this.state.row.documentId || this.state.row.documentId==='' )) {
			Alert.error("Fatura Kesilmiş, Fatura No Zorunludur!", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 3000
			});
			return;
		}

		let params = {
			url: "/progresspayment/updateHakedisState",
			method: 'post',
			data: {"recordId": this.state.row.recordId,
					"state" : this.state.row.state.recordId,
					"documentId" : this.state.row.documentId }
		};

		this.setState({processing: true});
		request(params).then(function (response) {
			self.setState({processing: false});
			self.toggleModal();
		}).catch(function (error) {
			self.setState({processing: false});
			showAxiosError(error);
		});
	}


	onChangeState(event) {
		console.log(event);
		const target = event.target;
		const value = target.value;
		const id = target.id;
		console.log(target,value);
		let row = this.state.row;
		let state = row.state;
		state[id] = value;
		this.setState({row},()=>console.log("this.state.row",this.state.row));
	}

	onChange(event) {
		const target = event.target;
		const name = target.name;
		const value = target.value;
		console.log(target,value);
		let row = this.state.row;
		row[name] = value;
		this.setState({row},()=>console.log("this.state.row",this.state.row));
	}

	render() {
		let inputClasses = "form-control"
		console.log(this.state.row);
		return (
			<Modal isOpen={this.state.show} keyboard={true} size="md">
				<ModalHeader toggle={this.toggleModal}>Hakediş Durum Güncelleme</ModalHeader>
				<ModalBody>
					{this.state.processing &&
					<div className="row"><span className="pull-right">Yükleniyor..</span></div>}
					<Form>
						<FormGroup row>
							<div className="col-sm-12 row">
								<label className="col-sm-4 col-form-label">Hakediş Durumu</label>
								<div className="col-sm-8">
									<Select
										id="state"
										value={this.state.row.state.recordId}
										placeholder="Seçiniz..."
										clearable={false}
										onChange={(e) => e && this.onChangeState({
											target: {
												id: "recordId",
												value: e.value
											}
										})}
										options={this.state.hakedisStates.map(state => ({
											value: state.recordId,
											label: state.description
										}))}
										disabled={this.state.processing}
									/>
								</div>
							</div>
							<div className="col-sm-12 row"/>
							<div className="col-sm-12 row">
								<label className="col-sm-4 col-form-label">Fatura No</label>
								<div className="col-sm-8">
									<input
										id="documentId"
										name="documentId"
										value={this.state.row.documentId}
										placeholder="Fatura No"
										type="text"
										style={{flex:"1",fontSize:"12px"}}
										data-vlength="1,50"
										onChange={(e) => this.onChange(e)}
										disabled={this.state.processing}

									/>
								</div>
							</div>

						</FormGroup>
					</Form>
				</ModalBody>
				<ModalFooter>
					<div className="col-sm-12 row">
						<div className="col-sm-9"></div>
						<div className="col-sm-3">
							<button type="button" onClick={this.query} className="  TekBtn kaydet "
									disabled={this.state.processing}
									style={{padding: '9PX 43PX 9PX 15PX'}}>Kaydet
							</button>
						</div>
					</div>
				</ModalFooter>
			</Modal>
		)
	}
}

export default HakedisStateModal;



